@if (!optionListService.showWithdrawal) {
    <!-- failure messages -->
    @defer (when isVisible) {
        @if (!depositService.showDepositSuccess() && depositService.showDepositFailure) {
            <app-deposit-failure />
        }
    }
    <!-- additional messages like ada,arc,curfew,reversal etc.. -->
    @if (!depositService.showDepositSuccess()) {
        <bqd-dep-curfew-message (activeDepositCurfewInfo)="getActiveDepositCurfew($event)" />
        <app-additional-messages [selectedOption]="selectedOption" />
    }

    @if (depositService.showDepositInput() && !depositService.showDepositSuccess() && instrumentFormGroup) {
        <ng-container disabled="(kycPLverification && (ccFamily.includes(inputType) || inputType === 'PAYPAL')) ? true : null">
            <form
                class="cashier-form-wrapper qd-form-wrapper"
                [class.disableArea]="showAdaInteractionMessage()"
                [formGroup]="depositForm"
                (ngSubmit)="submitDeposit()">
                <div class="total-stake">
                    <span class="theme-info-i my-2 txt-sm-v2">
                        {{ 'PARTY.CASHIER.web.deposit.funds.text' | translate }} {{ fundsNeeded | vnCurrency }}&nbsp;
                    </span>
                </div>
                <!-- payment methods input -->
                <app-options-list [instrumentFormGroup]="instrumentFormGroup" (pyamentMethod)="updatePaymentMethod($event)" />
                <!-- Redirect messages -->
                @if (loaderService.depositRedirectInProgress()) {
                    <app-redirect-message />
                }

                <!-- submit deposit button -->
                <!-- <button type="submit" id="btnSubmitDeposit"  class="btn btn-primary w-100">                    
                    <span>{{'PARTY.CASHIER.web.deposit.placebet.button' | translate}}
                    </span>
                </button> -->
            </form>
        </ng-container>
    }
}
@defer (when optionListService.showWithdrawal) {
    <app-reversal-input />
}
